import { BrowserPlayer } from './Browser/BrowserPlayer';
import { ReachPlayer } from './Reach/ReachPlayer';
import { BrightSignPlayer } from './BrightSign/BrightSignPlayer';
import { PreviewPlayer } from './Preview/PreviewPlayer';
import { ScreenSaverPlayer } from './ScreenSaver/ScreenSaverPlayer';
import { FireOSPlayer } from './FireOS/FireOSPlayer';
import { ChromeExtensionPlayer } from './ChromeExtension/ChromeExtensionPlayer';
import { WebOSPlayer } from './WebOS/WebOSPlayer';
import { PWAPlayer } from './PWA/PWAPlayer';
import { PlatformInterface } from './interfaces';
import { BrightSignPmcPlayer } from './BrightSignPmc';
import { ReachPmcPlayer } from './ReachPmc/ReachPmcPlayer';

/**
 * Create Platform
 */
export function createPlatform(): PlatformInterface {
    let platformClass;

    const platformClasses = [
        BrowserPlayer,
        ScreenSaverPlayer,
        ReachPlayer,
        ReachPmcPlayer,
        BrightSignPlayer,
        BrightSignPmcPlayer,
        PreviewPlayer,
        FireOSPlayer,
        ChromeExtensionPlayer,
        WebOSPlayer,
        PWAPlayer,
    ];

    for (const thisPlatformClass of platformClasses) {
        let isThisClassTheRunningPlatform = false;
        try {
            isThisClassTheRunningPlatform = thisPlatformClass.isTheRunningPlatform();
        } catch (e) {
            console.warn(`Problem detecting the "${thisPlatformClass.name}" platform.`, e);
        }

        if (isThisClassTheRunningPlatform) {
            platformClass = thisPlatformClass;
            break;
        }
    }

    if (platformClass === undefined) {
        platformClass = BrowserPlayer;
    }

    const platform = new platformClass();
    console.debug(`Running the "${platform.name}" platform.`);

    // @ts-expect-error: TS cannot correctly parse the platforms that are written in JS
    return platform;
}
